import { render, staticRenderFns } from "./LpRadioLabelRepresent.vue?vue&type=template&id=6c8b9ee3&scoped=true"
import script from "./LpRadioLabelRepresent.vue?vue&type=script&lang=js"
export * from "./LpRadioLabelRepresent.vue?vue&type=script&lang=js"
import style0 from "./LpRadioLabelRepresent.vue?vue&type=style&index=0&id=6c8b9ee3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b9ee3",
  null
  
)

export default component.exports